<template>
  <div class="container mx-auto py-4">
    <div>
      <router-link
        to="/"
        type="button"
        class="mb-4 noprint"
        style="width: 8rem; padding: 0; color: #031425"
      >
        <svg
          data-slot="icon"
          fill="none"
          stroke-width="1.5"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
        </svg>
        <p>Ver eventos</p>
      </router-link>
      <div class="cashless">
        <div class="cash-body">
          <div class="cash-step noprint">Paso {{ step }} de 3</div>
          <div class="cash-head" :style="{ justifyContent: step !== 3 ? 'flex-start' : 'center' }">
            <b v-if="step < 3">{{ step === 1 ? 'Venta de' : 'Recarga' }} puntos</b>
            <b v-else>Recarga exitosa</b>
          </div>
          <form class="cash-form" @submit.prevent="validQr(1)" v-if="step === 1">
            <QRStream @qr-code="setCodeQr" v-if="showCamera" />
            <div class="cash-finder">
              <div class="finder">
                <label for="qr">Código:</label>
                <input
                  type="text"
                  name="qr"
                  id="qr"
                  v-model="user.code"
                  required
                  :disabled="blockQr"
                />
                <button v-if="blockQr" class="clean" @click="newRecharge">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.99967 8.9335L9.93301 10.8668C10.0552 10.9891 10.2108 11.0502 10.3997 11.0502C10.5886 11.0502 10.7441 10.9891 10.8663 10.8668C10.9886 10.7446 11.0497 10.5891 11.0497 10.4002C11.0497 10.2113 10.9886 10.0557 10.8663 9.9335L8.93301 8.00016L10.8663 6.06683C10.9886 5.94461 11.0497 5.78905 11.0497 5.60016C11.0497 5.41127 10.9886 5.25572 10.8663 5.1335C10.7441 5.01127 10.5886 4.95016 10.3997 4.95016C10.2108 4.95016 10.0552 5.01127 9.93301 5.1335L7.99967 7.06683L6.06634 5.1335C5.94412 5.01127 5.78856 4.95016 5.59967 4.95016C5.41079 4.95016 5.25523 5.01127 5.13301 5.1335C5.01079 5.25572 4.94967 5.41127 4.94967 5.60016C4.94967 5.78905 5.01079 5.94461 5.13301 6.06683L7.06634 8.00016L5.13301 9.9335C5.01079 10.0557 4.94967 10.2113 4.94967 10.4002C4.94967 10.5891 5.01079 10.7446 5.13301 10.8668C5.25523 10.9891 5.41079 11.0502 5.59967 11.0502C5.78856 11.0502 5.94412 10.9891 6.06634 10.8668L7.99967 8.9335ZM7.99967 14.6668C7.07745 14.6668 6.21079 14.4918 5.39967 14.1418C4.58856 13.7918 3.88301 13.3168 3.28301 12.7168C2.68301 12.1168 2.20801 11.4113 1.85801 10.6002C1.50801 9.78905 1.33301 8.92239 1.33301 8.00016C1.33301 7.07794 1.50801 6.21127 1.85801 5.40016C2.20801 4.58905 2.68301 3.8835 3.28301 3.2835C3.88301 2.6835 4.58856 2.2085 5.39967 1.8585C6.21079 1.5085 7.07745 1.3335 7.99967 1.3335C8.9219 1.3335 9.78856 1.5085 10.5997 1.8585C11.4108 2.2085 12.1163 2.6835 12.7163 3.2835C13.3163 3.8835 13.7913 4.58905 14.1413 5.40016C14.4913 6.21127 14.6663 7.07794 14.6663 8.00016C14.6663 8.92239 14.4913 9.78905 14.1413 10.6002C13.7913 11.4113 13.3163 12.1168 12.7163 12.7168C12.1163 13.3168 11.4108 13.7918 10.5997 14.1418C9.78856 14.4918 8.9219 14.6668 7.99967 14.6668ZM7.99967 13.3335C9.48856 13.3335 10.7497 12.8168 11.783 11.7835C12.8163 10.7502 13.333 9.48905 13.333 8.00016C13.333 6.51127 12.8163 5.25016 11.783 4.21683C10.7497 3.1835 9.48856 2.66683 7.99967 2.66683C6.51079 2.66683 5.24967 3.1835 4.21634 4.21683C3.18301 5.25016 2.66634 6.51127 2.66634 8.00016C2.66634 9.48905 3.18301 10.7502 4.21634 11.7835C5.24967 12.8168 6.51079 13.3335 7.99967 13.3335Z"
                      fill="#031425"
                    />
                  </svg>
                </button>
              </div>
              <button :class="{ danger: showCamera }" type="button" @click="showStream">
                <svg
                  data-slot="icon"
                  fill="none"
                  stroke-width="1.5"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                  v-if="!showCamera"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M3.75 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0 1 3.75 9.375v-4.5ZM3.75 14.625c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5a1.125 1.125 0 0 1-1.125-1.125v-4.5ZM13.5 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0 1 13.5 9.375v-4.5Z"
                  />
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M6.75 6.75h.75v.75h-.75v-.75ZM6.75 16.5h.75v.75h-.75v-.75ZM16.5 6.75h.75v.75h-.75v-.75ZM13.5 13.5h.75v.75h-.75v-.75ZM13.5 19.5h.75v.75h-.75v-.75ZM19.5 13.5h.75v.75h-.75v-.75ZM19.5 19.5h.75v.75h-.75v-.75ZM16.5 16.5h.75v.75h-.75v-.75Z"
                  />
                </svg>
                <svg
                  data-slot="icon"
                  fill="none"
                  stroke-width="1.5"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                  v-else
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="m15.75 10.5 4.72-4.72a.75.75 0 0 1 1.28.53v11.38a.75.75 0 0 1-1.28.53l-4.72-4.72M12 18.75H4.5a2.25 2.25 0 0 1-2.25-2.25V9m12.841 9.091L16.5 19.5m-1.409-1.409c.407-.407.659-.97.659-1.591v-9a2.25 2.25 0 0 0-2.25-2.25h-9c-.621 0-1.184.252-1.591.659m12.182 12.182L2.909 5.909M1.5 4.5l1.409 1.409"
                  />
                </svg>
              </button>
            </div>
            <div class="cash-info" v-if="showExtraInfo">
              <div class="cash-item">
                <label>Tipo de documento</label>
                <select v-model="user.documentType" :disabled="blockTypeDoc" required>
                  <option value="DNI">DNI</option>
                  <option value="CE">CE</option>
                  <option value="PASS">PASS</option>
                </select>
              </div>
              <div class="cash-item">
                <div class="cash-label">
                  <label>N° de documento</label>
                  <p>Opcional</p>
                </div>
                <input
                  v-model="user.document"
                  type="text"
                  :disabled="blockDocument"
                  :maxlength="user.documentType === 'DNI' ? 8 : 15"
                />
              </div>
              <div class="cash-item">
                <div class="">
                  <div class="cash-label">
                    <label>Correo electrónico</label>
                    <p>Opcional</p>
                  </div>
                  <input v-model="user.email" :disabled="blockEmail" type="email" />
                </div>
              </div>
            </div>
            <button type="submit" :disabled="disabledBtn" class="w-100 print" v-if="!blockQr">
              Validar
            </button>
            <button type="button" @click="validQr(2)" v-else class="primary w-100">
              Siguiente
            </button>
          </form>
          <form class="cash-form" @submit.prevent="chargePoints" v-if="step == 2">
            <div class="cash-points" v-if="user.userPoints">
              <p>Puntos disponibles:</p>
              <b>{{ Number(user.userPoints).toFixed(2) }}</b>
            </div>
            <div class="cash-user">
              <p>Código QR:</p>
              <b>{{ user.code }}</b>
            </div>
            <div class="cash-user" v-if="user.document && user.documentType">
              <p>{{ user.documentType }}:</p>
              <b>{{ user.document }}</b>
            </div>
            <div class="cash-user" v-if="user.email">
              <p>Correo electrónico:</p>
              <b>{{ user.email }}</b>
            </div>
            <div>
              <label for="amount">Monto a recargar:</label>
              <input
                v-model="amount"
                type="number"
                max="500"
                required
                name="amount"
                step="0.1"
                id="amount"
              />
            </div>
            <div class="cash-payment">
              <div class="">
                <label>Método de pago:</label>
                <select v-model="paymentMethod" class="form-control" required>
                  <option value="efectivo">Efectivo</option>
                  <option value="pos">POS</option>
                  <option value="yape">Yape</option>
                </select>
              </div>
              <template v-if="paymentMethod === 'pos'">
                <div class="">
                  <label>POS Store:</label>
                  <select v-model="posType" class="form-control" required>
                    <option value="izipay">Izipay</option>
                    <option value="niubiz">Niubiz</option>
                  </select>
                </div>
                <div class="">
                  <label>Red de pago:</label>
                  <select v-model="paymentRed" class="form-control" required>
                    <option value="VISA">Visa</option>
                    <option value="MASTERCARD">Mastercard</option>
                    <option value="DINNERS">Dinners</option>
                    <option value="AMEX">Amex</option>
                    <option value="OTRAS">Otras</option>
                  </select>
                </div>
                <div>
                  <label for="amount">Nro. Operación:</label>
                  <input
                    v-model="paymentCode"
                    type="text"
                    name="amount"
                    id="amount"
                    required
                    placeholder="Código de operación"
                  />
                </div>
              </template>
              <template v-if="paymentMethod === 'efectivo'">
                <div>
                  <label for="amount">Monto recibido:</label>
                  <input
                    v-model="cash"
                    type="number"
                    name="amount"
                    id="amount"
                    step="0.1"
                    required
                  />
                </div>
                <div class="turned" v-if="cashTurned > 0">
                  <label for="amount">Vuelto:</label>
                  <b>S/ {{ cashTurned }}</b>
                </div>
              </template>
              <button type="submit" :disabled="disabledBtn" class="primary">Recargar</button>
            </div>
          </form>
          <div class="cash-success" v-if="step == 3">
            <div style="margin-bottom: 1rem">
              <p style="text-align: center; font-weight: 500">Evento</p>
              <b>{{ transaction.event.title }}</b>
            </div>
            <p style="font-weight: 500" v-if="hourPrint">Fecha de emisión: {{ hourPrint }}</p>
            <img
              width="150"
              height="150"
              :src="`https://qr.joinnus.com/qr.png?size=150&body=${transaction.qrCode}`"
              alt=""
            />
            <b>{{ transaction.qrCode }}</b>
            <div class="amount">
              <p style="font-weight: 500">Puntos disponibles</p>
              <b>{{ Number(transaction.points).toFixed(2) }}</b>
            </div>
            <div class="remember">
              <b>Recuerda</b>
              <ul>
                <li>
                  <p>Este documento no es un comprobante de pago.</p>
                </li>
                <li>
                  <p>No hay devolución/reembolso de dinero.</p>
                </li>
              </ul>
              <p style="align-self: center">Para ver tus saldos y movimientos, ingresa a:</p>
              <b style="align-self: center">miscompras.joinnus.com</b>
            </div>
            <div class="options noprint" @click="printInvoice">
              <button class="print">
                <svg
                  data-slot="icon"
                  fill="none"
                  stroke-width="1.5"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M6.72 13.829c-.24.03-.48.062-.72.096m.72-.096a42.415 42.415 0 0 1 10.56 0m-10.56 0L6.34 18m10.94-4.171c.24.03.48.062.72.096m-.72-.096L17.66 18m0 0 .229 2.523a1.125 1.125 0 0 1-1.12 1.227H7.231c-.662 0-1.18-.568-1.12-1.227L6.34 18m11.318 0h1.091A2.25 2.25 0 0 0 21 15.75V9.456c0-1.081-.768-2.015-1.837-2.175a48.055 48.055 0 0 0-1.913-.247M6.34 18H5.25A2.25 2.25 0 0 1 3 15.75V9.456c0-1.081.768-2.015 1.837-2.175a48.041 48.041 0 0 1 1.913-.247m10.5 0a48.536 48.536 0 0 0-10.5 0m10.5 0V3.375c0-.621-.504-1.125-1.125-1.125h-8.25c-.621 0-1.125.504-1.125 1.125v3.659M18 10.5h.008v.008H18V10.5Zm-3 0h.008v.008H15V10.5Z"
                  />
                </svg>
                <p>Imprimir</p>
              </button>
              <button type="button" class="new" style="gap: 0.5rem" @click="newRecharge">
                <svg
                  data-slot="icon"
                  fill="none"
                  stroke-width="1.5"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M16.5 6v.75m0 3v.75m0 3v.75m0 3V18m-9-5.25h5.25M7.5 15h3M3.375 5.25c-.621 0-1.125.504-1.125 1.125v3.026a2.999 2.999 0 0 1 0 5.198v3.026c0 .621.504 1.125 1.125 1.125h17.25c.621 0 1.125-.504 1.125-1.125v-3.026a2.999 2.999 0 0 1 0-5.198V6.375c0-.621-.504-1.125-1.125-1.125H3.375Z"
                  />
                </svg>
                <p>Nueva Recarga</p>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from '../api';
import QRStream from '../components/QRStream.vue';
export default {
  components: {
    QRStream
  },
  data() {
    return {
      user: {
        id: 0,
        code: '',
        documentType: 'DNI',
        document: '',
        email: '',
        userPoints: null
      },
      step: 1,
      amount: 0,
      paymentMethod: 'efectivo',
      posType: 'izipay',
      paymentRed: 'VISA',
      paymentCode: '',
      cash: 0,
      disabledBtn: false,
      hourPrint: null,
      transaction: null,
      showCamera: false,
      showExtraInfo: false,
      blockTypeDoc: false,
      blockDocument: false,
      blockEmail: false,
      blockQr: false
    };
  },
  methods: {
    async validQr(step) {
      this.$toasted.clear();
      const { user, blockQr } = this;
      const { eventId } = this.$route.params;
      if (blockQr) {
        this.$toasted.info('Validando datos adicionales');
      } else {
        this.$toasted.info('Validando Código Qr');
      }
      try {
        this.disabledBtn = true;
        this.showCamera = false;
        const payload = {
          activityId: eventId,
          code: user.code,
          documentType: user.documentType,
          document: user.document,
          email: user.email,
          name: '',
          lastname: ''
        };
        const res = await api.validateQr(payload);
        const { data, status, message } = res;
        if (status) {
          this.blockQr = true;
          if (data.invitedDocument) {
            user.document = data.invitedDocument;
            if (data.invitedDocument !== '00121212') {
              this.blockDocument = true;
            }
          }
          if (data.documentType) {
            user.documentType = data.documentType;
            this.blockTypeDoc = true;
          }
          if (data.email) {
            user.email = data.email;
            if (data.email !== 'generico@joinnus.com') {
              this.blockEmail = true;
            }
          }
          if (data.id) {
            user.id = data.userId;
          }
          if (data.userPoints) {
            user.userPoints = data.userPoints;
          }
          this.showExtraInfo = true;
          this.step = step;
          this.$toasted.success('Código validado');
        } else {
          this.$toasted.error(message);
        }
      } catch (error) {
        this.$toasted.error('Oppss.. algo salió mal');
      } finally {
        this.disabledBtn = false;
      }
    },
    async chargePoints() {
      this.$toasted.clear();
      const { cashTurned, paymentMethod, amount, user, paymentCode, paymentRed, cash } = this;
      if (amount <= 0) {
        return this.$toasted.error('El monto a recargar debe ser mayor 0');
      }
      if (amount > 500) {
        return this.$toasted.error('Monto máximo de recarga 500');
      }
      if (paymentMethod === 'efectivo') {
        if (Number(cashTurned) < 0) {
          return this.$toasted.error('El monto recibido es menor al monto a recargar.');
        }
      }
      if (paymentMethod === 'pos') {
        if (!paymentCode) {
          return this.$toasted.error('Ingrese el código de operación');
        }
      }
      try {
        this.disabledBtn = true;
        const { token } = this.$store.state.auth;
        const { eventId } = this.$route.params;
        const payload = {
          eventId,
          userCode: user.code,
          user: {
            id: user.id,
            email: '',
            document: user.document,
            documentType: user.documentType,
            session: null
          },
          sessionId: token,
          paymentMethod,
          amount,
          methods: [
            {
              method: paymentMethod,
              amount: amount,
              amountPayed: paymentMethod !== 'efectivo' ? amount : cash,
              amountReturned: cashTurned
            }
          ],
          utmSource: 'punto-venta'
        };
        if (paymentMethod === 'pos') {
          payload.cardType = paymentRed;
          payload.paymentTransactionId = paymentCode;
          payload.methods[0].cardType = paymentRed;
          payload.methods[0].paymentTransactionId = paymentCode;
        }
        const res = await api.paymentPoints(payload);
        if (res.success) {
          this.transaction = res;
          this.step = 3;
          this.$toasted.success('Recarga exitosa');
        } else {
          this.$toasted.error('Hubo un error al procesar la recarga');
        }
      } catch (error) {
        this.$toasted.error('Hubo un error al procesar la recarga');
        console.log(error);
      } finally {
        setTimeout(() => {
          this.disabledBtn = false;
        }, 3000);
      }
    },
    printInvoice() {
      const date = new Date();
      const options = {
        hour: '2-digit',
        minute: '2-digit',
        month: 'short',
        day: 'numeric'
      };
      this.hourPrint = date.toLocaleDateString('es-CO', options);
      setTimeout(() => {
        window.print();
      }, 200);
    },
    newRecharge() {
      this.user = {
        id: 0,
        code: '',
        documentType: 'DNI',
        document: ''
      };
      this.step = 1;
      this.amount = 0;
      this.paymentMethod = 'efectivo';
      this.posType = 'izipay';
      this.paymentRed = 'VISA';
      this.paymentCode = '';
      this.cash = 0;
      this.disabledBtn = false;
      this.hourPrint = null;
      this.transaction = null;
      this.blockDocument = false;
      this.blockTypeDoc = false;
      this.blockEmail = false;
      this.blockQr = false;
      this.showExtraInfo = false;
    },
    setCodeQr(value) {
      this.user.code = value;
      this.showCamera = false;
      this.validQr(1);
    },
    showStream() {
      if (this.blockQr) {
        return;
      }
      this.showCamera = !this.showCamera;
    }
  },
  computed: {
    cashTurned() {
      let total = 0;
      const { cash, amount, paymentMethod } = this;
      if (paymentMethod === 'efectivo') {
        total = cash - amount;
      }
      return Number(total).toFixed(2);
    }
  }
};
</script>
<style lang="scss" scoped>
.qrcode-stream-camera {
  border-radius: 2rem;
}
p {
  margin-bottom: 0;
}
button,
a {
  background: transparent;
  border: 1px solid transparent;
  display: flex;
  font-weight: 700;
  text-align: center;
  align-items: center;
  justify-content: center;
  border-radius: 1rem;
  padding: 0.5rem;
  svg {
    width: 1.5rem;
    height: 1.5rem;
  }
  &:disabled {
    opacity: 0.6;
  }
}
a {
  &:hover {
    text-decoration: underline;
    text-underline-offset: 0.25rem;
  }
}
label {
  font-weight: 600;
}
input,
select {
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  border: 1px solid #031425;
  width: 100%;
  height: 2.5rem;
  font-weight: 500;
  color: #031425 !important;
  &:focus,
  &:focus-visible {
    border-color: #00e0b1;
    outline-color: #00e0b1;
    box-shadow: 0 0 0 0.05rem #00e0b1;
  }
  &:disabled {
    opacity: 0.6;
  }
}
.cashless {
  color: #031425;
  background: #fff;
  box-shadow: 0 10px 15px -3px #00000020, 0 4px 6px -4px #00000020;
  border-radius: 0.5rem;
  padding: 2rem 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  .cash-body {
    max-width: 26rem;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
  .cash-step {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    font-size: 0.85rem;
    height: 2rem;
    font-weight: 800;
    svg {
      width: 1rem;
      height: 1rem;
    }
  }
  .cash-head {
    display: flex;
    align-items: center;
    b {
      font-size: 1.5rem;
    }
  }
  .cash-form {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    .cash-user {
      display: flex;
      align-items: center;
      padding: 1rem;
      border: 1px solid #bcd1e7;
      border-radius: 0.5rem;
      font-weight: 500;
      background: #f8fafd;
      gap: 0.5rem;
    }
    .cash-points {
      display: flex;
      align-items: center;
      padding: 1rem;
      border: 2px solid #00e0b1;
      border-radius: 0.5rem;
      font-weight: 500;
      background: #00e0b140;
      gap: 0.5rem;
    }
  }
  .cash-finder {
    display: flex;
    align-items: center;
    gap: 1rem;
    .finder {
      display: flex;
      flex-direction: column;
      flex-grow: 1;
      position: relative;
      .clean {
        position: absolute;
        z-index: 10;
        right: 0.5rem;
        top: 2.25rem;
        padding: 0;
        border: 0;
        svg {
          width: 1.5rem;
          height: 1.5rem;
        }
      }
    }
    button {
      border: 2px solid #00e0b1;
      align-self: flex-end;
      svg {
        width: 2rem;
        height: 2rem;
      }
    }
  }
  .cash-info {
    display: grid;
    grid-template-columns: repeat(1, minmax(0, 1fr));
    gap: 1rem;
    .cash-item {
      display: flex;
      flex-direction: column;
      .cash-label {
        display: flex;
        align-items: center;
        justify-content: space-between;
        p {
          font-size: 0.7rem;
          font-weight: 500;
        }
      }
    }
  }
  .cash-payment {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    .turned {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    b {
      font-size: 1.5rem;
    }
  }
  .cash-success {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
    .amount {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-top: 1rem;
      b {
        font-size: 1.75rem;
      }
    }
    .remember {
      font-size: 0.875rem;
      font-weight: 500;
      display: flex;
      flex-direction: column;
    }
    .options {
      display: flex;
      align-items: center;
      margin-top: 1rem;
      gap: 1rem;
      width: 100%;
      flex-direction: column;
      @media screen and (min-width: 640px) {
        flex-direction: row;
      }
    }
  }
}
.primary {
  background: #00e0b1;
}
.danger {
  border-color: #dc3545 !important;
  color: #dc3545;
}
.new {
  background: #00e0b1;
  color: #031425;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  width: 100%;
  @media screen and (min-width: 640px) {
    width: 50%;
  }
}
.print {
  background: #031425;
  color: #fff;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  width: 100%;
  @media screen and (min-width: 640px) {
    width: 50%;
  }
}
@media print {
  .noprint {
    display: none !important;
  }
}
</style>
